import { FC } from 'react'
import DashboardWidgetShell from './DashboardWidgetShell'
import DashboardHeaderCounters from './DashboardHeaderCounters'
import DashboardAppraisalMonitoringWidget from './DashboardAppraisalMonitoringWidget'
import '../styles/dashboard-view-layout.less'
import DashboardFiltersArea from './DashboardFiltersArea'

const DashboardViewLayout: FC = () => {
  return (
    <div className="dashboard-view-layout">
      <DashboardWidgetShell className="dashboard-view-layout__top-widget">
        <DashboardHeaderCounters />
      </DashboardWidgetShell>

      <section className="dashboard-view-layout__main-row">
        <DashboardWidgetShell noPadding>
          <DashboardFiltersArea />
        </DashboardWidgetShell>
        <DashboardWidgetShell noPadding>
          <DashboardAppraisalMonitoringWidget />
        </DashboardWidgetShell>
      </section>
    </div>
  )
}

export default DashboardViewLayout
